module.exports = __webpack_public_path__ + "img/draggable-cart-on-wheels.5fe32ac7.jpg";